import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'breadcrumbs',
  template: `
  <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs" let-last = last>
    <li class="breadcrumb-item" *ngIf="breadcrumb.label.title&&breadcrumb.url.substring(breadcrumb.url.length-1) == '/' || breadcrumb.label.title&&last" [ngClass]="{active: last}">
      <a *ngIf="!last && breadcrumb.label.title == 'Inicio'" href="#/dashboard">{{breadcrumb.label.title}}</a>
      <a *ngIf="!last && breadcrumb.label.title != 'Inicio'" [routerLink]="getRuta(breadcrumb)">{{breadcrumb.label.title}}</a>
      <span *ngIf="last" [routerLink]="getRuta(breadcrumb)">{{breadcrumb.label.title}}</span>
    </li>
  </ng-template>`
})
export class BreadcrumbsComponent {
  breadcrumbs: Array<Object>;
  constructor(private router: Router, private route: ActivatedRoute) { }
  ngOnInit(): void {
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
      this.breadcrumbs = [];
      let currentRoute = this.route.root,
        url = '';
      do {
        let childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(route => {
          if (route.outlet === 'primary') {
            let routeSnapshot = route.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
            this.breadcrumbs.push({
              label: route.snapshot.data,
              url: url,
              primary: routeSnapshot.data.primary
            });
            currentRoute = route;
          }
        });
      } while (currentRoute);
    });
  }

  private isPrimary(data) {
    if (data.primary !== void 0 && data.primary === true) {
      return true;
    }
    return false;
  }

  getRuta(data) {
    if (data.primary == true) {
      return data.url + '//index';
    }
    return data.url;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/breadcrumb.component.ts